import {
  CountrySubdivisionCityFieldInternal,
  componentName,
} from './CountrySubdivisionCityFieldInternal';

customElements.define(componentName, CountrySubdivisionCityFieldInternal);
